import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getChatApiUrl } from './chat.paths';

export type TokenResponse = {
  token: string;
  channelTypes: string[];
  channelGrants: string[];
};

const createGetStreamToken = async () => {
  const res = await http.post<ApiResponseBody<TokenResponse>>(getChatApiUrl.getStreamToken());

  return res.data.data;
};

export const chatApiFetcher = {
  createGetStreamToken,
};
